module.exports = __webpack_public_path__ + "static/product-13c51bfeac4e06f34e2654f8c87bb193.jpg";